export default {
    dashboard_delete_chart_title: "Borrar panel de control",
    dashboard_delete_chart_description: "¿Estás seguro de que quieres eliminar este Gadget?",
    dashboard_delete_success_message: "El gadget ha sido eliminado",
}